export class OutreachAttemptEvidence {
  id: number;
  notes: string;
  lastOutreachDate: Date;
  officeIds: number[];
  patientPrescriberId: number;
}
